import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ContentContainer, ScrollableListBasic, StyledTypography } from './ui';

export type ErrorContentProps = {
    errors: string;
};

/* eslint-disable react/no-array-index-key */
const ErrorContent = ({ errors }: ErrorContentProps) => {
    const { t } = useTranslation('importExportExcel');
    const errorList = errors.split('\n');

    return (
        <ContentContainer direction="vertical">
            <StyledTypography>{t('importExportExcel:description.errorTitle')}</StyledTypography>
            <ScrollableListBasic>
                {errorList.map((error, i) => (
                    <li key={i}>
                        <Typography>{error}</Typography>
                    </li>
                ))}
            </ScrollableListBasic>
        </ContentContainer>
    );
};

export default ErrorContent;
